import React, { useEffect, useState } from "react";
import EventForm from "../components/EventForm";
import { Link } from "react-router-dom";
import { pageNames } from "../../config/pageNames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "providers/authProvider";

const CreateEventPage = () => {
  const { user } = useAuth();
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() =>{
    if(user){
      setUserEmail(user?.email ?? null)
    }
    setLoading(false);
  }, [user]);

  return (
    <div className='event-container'>
      { loading &&
        <div className='mx-3'>Loading ... </div>
      }
      <div className='mx-3'>
        <Link to={pageNames.EVENT} style={{ textDecoration: "none" }}>
          <FontAwesomeIcon icon={faChevronLeft} />
          Events
        </Link>
        <EventForm userEmail={userEmail!} />
      </div>
    </div>
  );
};

export default CreateEventPage;
